import OrderStatus from '@/components/Orders/OrderStatus/OrderStatus'
import type { OrderInterface, OrderShortType } from '@/types'

import cn from './OrderCard.module.scss'

type OrderCardProps = {
  order: OrderInterface['orderModel'] | OrderShortType
  onClick?: () => void
}

const OrderCard = ({ order, onClick }: OrderCardProps) => {
  const client =
    'clientShortModel' in order && order.clientShortModel
      ? order.clientShortModel.description ||
        order.clientShortModel.shortLegalName ||
        '—'
      : '—'

  const author =
    'author' in order
      ? order.author || '—'
      : order.authorShortModel?.description || '—'

  const contract =
    ('contractShortModel' in order && order.contractShortModel?.description) ||
    '—'

  const deliveryAddress =
    'deliveryAddress' in order && order.deliveryAddress
      ? order.deliveryAddress
      : 'Самовывоз'

  const comment = (order.comment as string) || null

  const date = new Date(order.createdAt)
  const formattedDate = date.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
  const formattedTime = date.toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
  })

  return (
    <div className={cn.orderCard} onClick={onClick}>
      <div className={cn.header}>
        <div className={cn.statusWrap}>
          <OrderStatus order={order} />
        </div>
        <span className={cn.code}>#{order.code}</span>
        <span className={cn.date}>
          {formattedDate} {formattedTime}
        </span>
      </div>

      <div className={cn.body}>
        <div className={cn.row}>
          <span className={cn.label}>Клиент</span>
          <span className={cn.value}>{client}</span>
        </div>
        <div className={cn.row}>
          <span className={cn.label}>Автор</span>
          <span className={cn.value}>{author}</span>
        </div>
        <div className={cn.row}>
          <span className={cn.label}>Сумма</span>
          <span className={cn.valueSum}>
            {order.totalPrice ? `${order.totalPrice} BYN` : '—'}
          </span>
        </div>
        <div className={cn.row}>
          <span className={cn.label}>Договор</span>
          <span className={cn.value}>{contract}</span>
        </div>
        <div className={cn.row}>
          <span className={cn.label}>Доставка</span>
          <span className={cn.value}>{deliveryAddress}</span>
        </div>
        {comment && (
          <div className={cn.row}>
            <span className={cn.label}>Комментарий</span>
            <span className={cn.value}>{comment}</span>
          </div>
        )}
      </div>
    </div>
  )
}

export default OrderCard
